import { jsx } from "react/jsx-runtime";
import { Inline, Box } from "braid-design-system";
import { useTranslations } from "@vocab/react";
import { translations } from "../../../../../components/CompanyProfileCarousel/hooks/usePaginationAriaLabel/.vocab/index.mjs";
import { bulletPointBase, selectedBackground, onReviewsPageUnselected } from "./BulletPoints.css.mjs";
function usePaginationAriaLabel({
  pageNumber,
  totalPages
}) {
  const { t } = useTranslations(translations);
  return t("Page {pageNumber} of {totalPages}", {
    pageNumber: `${pageNumber}`,
    totalPages: `${totalPages}`
  });
}
const BulletPoint = ({
  index,
  onReviewsLandingPage,
  focusedSlideIndex,
  goToSlide,
  numberOfBulletPoints = 3
}) => {
  const selected = focusedSlideIndex === index;
  const ariaLabel = usePaginationAriaLabel({
    pageNumber: index + 1,
    totalPages: numberOfBulletPoints
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "button",
      onClick: (event) => goToSlide(event, index),
      cursor: !selected ? "pointer" : void 0,
      className: [
        bulletPointBase,
        selected ? selectedBackground : void 0,
        !selected && onReviewsLandingPage ? onReviewsPageUnselected : void 0
      ],
      "aria-label": ariaLabel,
      "aria-current": selected ? "true" : "false"
    }
  );
};
const BulletPoints = ({
  focusedSlideIndex,
  moveSlidesLeft,
  moveSlidesRight,
  onReviewsLandingPage,
  numberOfBulletPoints = 3
}) => {
  const goToSlide = (event, slideIndex) => {
    if (slideIndex === focusedSlideIndex) {
      return;
    }
    const moveLeftOrRight = focusedSlideIndex - slideIndex;
    if (moveLeftOrRight > 0) {
      moveSlidesLeft(event, moveLeftOrRight);
    } else {
      moveSlidesRight(event, -moveLeftOrRight);
    }
  };
  return /* @__PURE__ */ jsx(Inline, { space: "xsmall", align: "center", children: new Array(numberOfBulletPoints).fill(null).map((_, index) => /* @__PURE__ */ jsx(
    BulletPoint,
    {
      index,
      numberOfBulletPoints,
      onReviewsLandingPage,
      focusedSlideIndex,
      goToSlide
    },
    index
  )) });
};
export {
  BulletPoints,
  usePaginationAriaLabel
};
